import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const items = [
  {
    title: 'Educación con humor',
    feedback:
      'Karla Aleska y Mariana abordan temas íntimos con rigor y risa inteligente: la marca se siente humana, no moralista ni fría.',
  },
  {
    title: 'Voces de 2do Escalón',
    feedback:
      'Toda la presencia en antena se concentra en el programa: micros «Minuto Prudence», cultura pop, bienestar y conversación sin tabúes con la audiencia joven.',
  },
  {
    title: 'Autoridad en buscadores',
    feedback:
      'TNO Digest captura tráfico de valor en Google sobre prevención, bienestar y salud reproductiva — activos que siguen trabajando semanas después.',
  },
];

const PorQueTNO = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography variant="h4" fontWeight={700} align="left" gutterBottom>
          ¿Por qué TNO Network
          <br />
          para Prudence?
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              width="100%"
              height="100%"
              data-aos="fade-up"
              component={Card}
              display="flex"
              flexDirection="column"
              sx={{ borderTop: 4, borderColor: theme.palette.primary.main }}
            >
              <CardContent sx={{ flex: 1 }}>
                <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                  {item.title}
                </Typography>
                <Typography color="textSecondary">{item.feedback}</Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PorQueTNO;
